import React from "react";
import logoGF from "../images/logo.png";

const LoadingLogo = () => {
  const companyLogo = localStorage.getItem("logo");
  
  const handleImageError = (e) => {
    e.target.src = logoGF;
    e.target.style.width = "150px";
    e.target.style.height = "50px";
  };

  return (
    <div className="flex flex-col items-center justify-center py-20">
      {companyLogo ? (
        <img src={companyLogo} alt="Company Logo" className="h-20 w-auto mb-4" onError={handleImageError}/>
      ) : (
        <img src={logoGF} alt="Company Logo" className="h-20 w-auto mb-4" onError={handleImageError}/>
      )}

      <div className="w-48 h-[2px] bg-gray-300 rounded-full overflow-hidden relative">
        <div className="h-[2px] bg-[#6B78F8] w-1/3 absolute left-0 animate-moving-line"></div>
      </div>
    </div>
  );
};

export default LoadingLogo;
